import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PagePayload } from '@core/interface/core';
import {
  SORResponse,
  SORItem,
  AddSORResponse,
  SORCommonResponse,
} from '@core/interface/sor';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class SorService {
  constructor(private http: HttpClient) {}

  getSORs(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<SORResponse>(environment.endPoints.SORList, {
      params: httpParams,
    });
  }
  addSOR(data: SORItem) {
    return this.http.post<AddSORResponse>(
      environment.endPoints.SORAddEdit,
      data
    );
  }
  deleteSOR(id: number) {
    return this.http.get<SORCommonResponse>(
      environment.endPoints.SORDelete(id),
      { observe: 'response' }
    );
  }
}
